module.exports = __webpack_public_path__ + "static/img/buyer_logo_34.31a8e0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buyer/buyer_logo_34.jpg
// module id = J2cW
// module chunks = 0